import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.bowlingSet || initialState;

export const selectBowlingSet = createSelector([selectSlice], state => state);
